import * as Yup from 'yup';
import type { Message } from 'yup/lib/types';

import { isTurnstileBypassAllowed } from 'services/cloudflare';

declare module 'yup' {
  interface StringSchema {
    turnstileRequired(message: Message): this;
  }
}

Yup.addMethod<Yup.StringSchema>(
  Yup.string,
  'turnstileRequired',
  function (message: Message) {
    const isTurnstileRequired = !isTurnstileBypassAllowed();

    return isTurnstileRequired ? this.required(message) : this.notRequired();
  }
);
